import { getElementsByClassName } from '../../../../../utils/utils';
export class TextSizeOverflowBorder {
    parent;
    cachedOverflowBorders = [];
    constructor(parent) {
        this.parent = parent;
    }
    get performer() {
        return this.parent.parent;
    }
    get overflowBorders() {
        return getElementsByClassName(`overflowBorder_${this.performer.group.groupName}`);
    }
    cacheOverflowBorders() {
        this.cachedOverflowBorders = this.overflowBorders;
    }
    get hasOverflow() {
        return !!this.cachedOverflowBorders.find(el => this.doesElementHaveOverflow(el));
    }
    doesElementHaveOverflow(el) {
        if (el.nodeName === 'INPUT') {
            const divEl = document.createElement('div');
            const computedStyle = getComputedStyle(el);
            if (computedStyle.cssText !== '') {
                divEl.style.cssText = computedStyle.cssText;
            }
            divEl.style.position = 'absolute';
            if (el.aspect && el.aspect.parent.type === 'wordtask') {
                const wordTask = el.aspect.parent;
                divEl.innerText = wordTask.wordTaskForm.longestWording;
            }
            else {
                divEl.innerText = el.value;
            }
            document.body.appendChild(divEl);
            const hasOverflow = this.doesElementHaveOverflow(divEl);
            document.body.removeChild(divEl);
            return hasOverflow;
        }
        const overFlowState = this.overFlowStateOfElement(el);
        if (overFlowState.overflowWidth > 0 || overFlowState.overflowHeight > 0) {
            return true;
        }
        if (el.style.paddingLeft || el.style.paddingRight || el.style.paddingTop || el.style.paddingBottom) {
            if (this.doesAnyChildExceedCssWidth(el)) {
                return true;
            }
        }
        return false;
    }
    overFlowStateOfElement(el) {
        // algorithm from https://stackoverflow.com/questions/143815/determine-if-an-html-elements-content-overflows
        const currentOverflow = el.style.overflow;
        if (!currentOverflow || currentOverflow === 'visible')
            el.style.overflow = 'hidden';
        const overflowState = {
            overflowWidth: el.scrollWidth - el.clientWidth,
            overflowHeight: el.scrollHeight - el.clientHeight
        };
        el.style.overflow = currentOverflow;
        return overflowState;
    }
    doesAnyChildExceedCssWidth(el) {
        // potentially slow!
        // https://stackoverflow.com/questions/21064101/understanding-offsetwidth-clientwidth-scrollwidth-and-height-respectively
        const computedStyle = getComputedStyle(el);
        const cssHeight = el.clientHeight - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom);
        const cssWidth = el.clientWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
        const childNodes = Array.from(el.childNodes);
        for (const child of childNodes) {
            if (child.clientWidth > cssWidth + 1) {
                // +1 rounding issues when same height image inside
                return true;
            }
            if (child.clientHeight > cssHeight + 1) {
                // +1 rounding issues when same height image inside
                return true;
            }
        }
        return false;
    }
}
